/**
 * This enum represents the internal state of an application in the context of advisors working on them.
 */
export enum WorkflowState {
    Active = 0,
    Cancelled = 1,
    OnHold = 2,
    Completed = 3,
}

export const WorkflowStateLabels: Record<WorkflowState, string> = {
    [WorkflowState.Active]: 'Active',
    [WorkflowState.Cancelled]: 'Cancelled',
    [WorkflowState.OnHold]: 'On Hold',
    [WorkflowState.Completed]: 'Completed',
};
